export default "__VITE_ASSET__CgdA5gNU__";